'use strict';

exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
};

exports.default = isClassComponent;


/** WEBPACK FOOTER **
 ** ./src/app/modules/login/~/recompose/isClassComponent.js
 **/